module.exports = __webpack_public_path__ + "img/people_big28.f5857439.png";